export default "__VITE_ASSET__CTKd7Zof__"